import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import { useState } from "react";
import { IconField } from "primereact/iconfield";
import { InputIcon } from "primereact/inputicon";
import { InputText } from "primereact/inputtext";
import { useEffect } from "react";

import { getWarehouseGarmentsByStageProcessStatus } from "../../services/warehouse/WarehouseProcess";
import { ProgressSpinner } from "primereact/progressspinner";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";

const WarehouseDashboardQrCodeListStageWise = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { recordType } = location.state || {}; // Fallback to prevent undefined errors

  const { warehouseData } = getUserData();

  let warehouseId = warehouseData.id;

  // If orderFilterData is available, use its start and end dates
  const [challanData, setChallanData] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchTermView, setSearchTermView] = useState(false);

  const [countData, setCountData] = useState("");
  const [sumOfGarmentCount, setSumOfGarmentCount] = useState(0);
  const [loading, setLoading] = useState(false);

  const initializeVariable = () => {
    setChallanData([]);
  };
  useEffect(() => {
    const data = {
      status: [recordType],
    };
    initializeVariable();
    getWarehouseGarmentsByStageProcessStatus(warehouseId, data)
      .then((response) => {
        setLoading(true);
        if (!response.data.error) {
          const Res = response.data;
          setChallanData(Res);
          updateTotals(Res);
          setLoading(false);
        }
      })
      .catch((err) => {
        console.error("Error:", err);
      });
  }, []);

  const handleClearSearch = () => {
    setSearchTerm("");
  };

  const updateTotals = (orders) => {
    const statusTotals = orders.reduce((acc, order) => {
      const existingStatus = acc.find(
        (item) => item.stagePriority === order.qrCodeInfo.stagePriority
      );

      if (existingStatus) {
        existingStatus.orderCount += 1;
      } else {
        acc.push({
          currentStage: order.qrCodeInfo.currentStage,
          stagePriority: order.qrCodeInfo.stagePriority,
          orderCount: 1,
        });
      }
      return acc;
    }, []);
    const totalGarmentCountData = statusTotals.reduce(
      (acc, item) => acc + item.orderCount,
      0
    );

    setCountData(statusTotals);
    setSumOfGarmentCount(totalGarmentCountData);
  };

  const OrderStatusColors = {
    1: "#09B4AA",
    2: "#55BD5A",
    3: "#5D53D8",
    4: "#09B4AA",
    5: "#55BD5A",
    6: "#FF6767",
    7: "#5D53D8",
    8: "#6EA4F5",
    9: "#E89534",
    10: "#a906c2",
    0: "#a906c2",
  };

  const renderPaymentModeButtons = () => {
    return countData.map((item) => (
      <div
        key={item?.stagePriority}
        style={{ backgroundColor: OrderStatusColors[item?.stagePriority] }}
        className="px-3 py-2 border-round-md"
      >
        <p className="text-white text-lg font-bold uppercase">
          {item.orderCount}{" "}
          {item.stagePriority !== null
            ? " - (P - " + item.stagePriority + ")"
            : ""}{" "}
          -{" "}
          {item.stagePriority < 1 || item.stagePriority === null
            ? "No Stage"
            : item?.currentStage?.replace(/_/g, " ")}
        </p>
      </div>
    ));
  };

  const OrderStatusColorStage = {
    BOOKED: "#3EB3E1",
    INPROCESS: "#866CCE",
    PROCESSED: "#F5C43A",
    DELIVERED: "#09B4AA",
    DONE: "#55BD5A",
    CANCEL: "#FF6767",
    UNPROCESSED: "#5D53D8",
    OUT_FOR_DELIVERY: "#6EA4F5",
    DELAY_STATUS: "E89534",
    IN_WAREHOUSE: "#a906c2",
    FACTORY: "#a906c2",
    DEFAULT: "#000",
  };

  const formatDateLedger = (dateString) => {
    const parsedDate = new Date(dateString.replace("Z", ""));

    return parsedDate.toLocaleString("en-GB", {
      month: "2-digit",
      day: "2-digit",
      year: "2-digit",
      hour12: true,
    });
  };

  const maxStagePriority = Math.max(
    ...challanData.map((item) => item.qrCodeInfo.stagePriority)
  );

  // Get unique currentStage values for the max stagePriority
  const uniqueStages = [
    ...new Map(
      challanData.map((item) => [
        item.qrCodeInfo.currentStage, // Using currentStage as the key to maintain uniqueness
        {
          currentStage: item.qrCodeInfo.currentStage.replace(/_/g, " "),
          stagePriority: item.qrCodeInfo.stagePriority,
        },
      ])
    ).values(),
  ].reverse();

  const filterOrderInfoList = () => {
    return challanData.filter((item) => {
      const qrCode = item.qrCodeInfo.qrCode.toLowerCase();
      const matchesSearchTermInvoiceNo = qrCode?.includes(
        searchTerm.toLowerCase()
      );
      return matchesSearchTermInvoiceNo;
    });
  };

  const filteredOrderInfoData = filterOrderInfoList();

  const RenderOldOrder = (filteredOrderInfoData) => {
    const getStageStatus = (stage, rowData) => {
      const stageLogs = rowData.stageLogs || {};
      const currentStagePriority = rowData.qrCodeInfo?.stagePriority || 0;

      if (stageLogs[stage]?.status === "PROCESSED") {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="green"
            class="bi bi-check-square-fill"
            viewBox="0 0 16 16"
          >
            <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
          </svg>
        );
      } else if (stageLogs[stage]?.status === "INPROCESS") {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="blue"
            class="bi bi-square-fill"
            viewBox="0 0 16 16"
          >
            <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" />
          </svg>
        );
      } else if (
        stage <= currentStagePriority &&
        stageLogs[stage]?.status === "None"
      ) {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="blue"
            class="bi bi-square"
            viewBox="0 0 16 16"
          >
            <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
          </svg>
        );
      }
      return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="red"
          class="bi bi-x-square"
          viewBox="0 0 16 16"
        >
          <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
          <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
        </svg>
      );
    };

    return (
      <DataTable
        value={filteredOrderInfoData}
        paginator
        rows={10}
        rowsPerPageOptions={[10, 25, 50]}
        tableStyle={{ minWidth: "50rem" }}
      >
        <Column
          header="S No."
          style={{ width: "80px" }}
          body={(rowData, options) =>
            options.rowIndex + 1}
        ></Column>
        <Column
          field="invoiceNo"
          header="Bill No"
          body={(rowData) =>
            rowData.qrCodeInfo?.qrCode?.match(/.*(?=OI)/)?.[0] ||
            rowData.qrCodeInfo?.qrCode
          }
        />
        <Column
          field="deliveryOn"
          header="Delivery Date"
          body={(rowData) =>
            formatDateLedger(rowData.qrCodeInfo?.deliveryOn || "")
          }
        />
        <Column
          field="dateOfDelivery"
          header="QR Code"
          body={(rowData) => rowData.qrCodeInfo?.qrCode || ""}
        />
        {uniqueStages.map((stage, i) => (
          <Column
            key={i}
            // header={`(P - ${i + 1}) ` + stage.currentStage} // Use the stage name here
            header={`(P - ${stage.stagePriority}) ` + stage.currentStage} // Use the stage name here
            body={(rowData) => getStageStatus(stage.stagePriority, rowData)}
          />
        ))}
        {/* {Array.from({ length: maxStagePriority }, (_, i) => (
          <Column
            key={i}
            header={`Stage ${i + 1}`}
            body={(rowData) => getStageStatus(i + 1, rowData)}
          />
        ))} */}
      </DataTable>
    );
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
                <i
                  className="pi pi-angle-left"
                  onClick={() => navigate("/")}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div>
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Order Status
              </p>
            </div>
          </div>

          <i
            className="pi pi-search"
            onClick={() => setSearchTermView(!searchTermView)}
            style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
          ></i>
        </div>
      </div>

      <div className="mx-4 my-2">
        {countData.length > 0 && (
          <div>
            <div
              className="flex gap-3 mb-3 pb-1 new-scroll-bar"
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <div
                style={{ backgroundColor: "#2B70D7" }}
                className="px-3 py-2 border-round-md"
              >
                <p className="text-white text-lg font-bold uppercase">
                  {sumOfGarmentCount} - All
                </p>
              </div>

              {renderPaymentModeButtons()}
            </div>
            <div
              className="flex gap-3 mb-3 pb-1 new-scroll-bar"
              style={{
                overflowX: "auto",
                whiteSpace: "nowrap",
              }}
            >
              <div className="flex justify-content-center align-items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="blue"
                  class="bi bi-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                </svg>
                <p className="text-lg font-bold uppercase">NOT STARTED</p>
              </div>
              <div className="flex justify-content-center align-items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="blue"
                  class="bi bi-square-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v12a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2z" />
                </svg>
                <p className="text-lg font-bold uppercase">STARTED</p>
              </div>
              <div className="flex justify-content-center align-items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="green"
                  class="bi bi-check-square-fill"
                  viewBox="0 0 16 16"
                >
                  <path d="M2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2zm10.03 4.97a.75.75 0 0 1 .011 1.05l-3.992 4.99a.75.75 0 0 1-1.08.02L4.324 8.384a.75.75 0 1 1 1.06-1.06l2.094 2.093 3.473-4.425a.75.75 0 0 1 1.08-.022z" />
                </svg>
                <p className="text-lg font-bold uppercase">DONE</p>
              </div>
              <div className="flex justify-content-center align-items-center gap-2">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="16"
                  height="16"
                  fill="red"
                  class="bi bi-x-square"
                  viewBox="0 0 16 16"
                >
                  <path d="M14 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                  <path d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" />
                </svg>
                <p className="text-lg font-bold uppercase">NOT ASSIGNED</p>
              </div>
            </div>
          </div>
        )}

        {searchTermView && (
          <div className="my-2 mx-1 flex flex-1">
            <div className="flex-1">
              <IconField iconPosition="left" className="flex flex-1">
                <InputIcon className="pi pi-search text-xl"> </InputIcon>
                <InputText
                  placeholder={"Search QrCode"}
                  value={searchTerm}
                  keyboardType={"numeric"}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  className="text-xl flex flex-1 py-1 px-5"
                  style={{ borderRadius: 30 }}
                />
              </IconField>
            </div>

            {searchTerm && (
              <div
                className="flex justify-content-center align-items-center mx-2 cursor-pointer"
                onClick={handleClearSearch}
              >
                <p className="text-3xl font-bold " style={{ color: "red" }}>
                  X
                </p>
              </div>
            )}
          </div>
        )}
        <div>
          {loading ? (
            <div className="flex flex-1 flex-column justify-content-center align-items-center">
              <ProgressSpinner />
              <p className="text-3xl font-bold">Loading Old Orders...</p>
            </div>
          ) : challanData.length > 0 ? (
            <div className="mx-4">{RenderOldOrder(filteredOrderInfoData)}</div>
          ) : (
            <div className="flex flex-1 justify-content-center align-items-center">
              <p className="text-3xl font-bold">No Orders Found</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default WarehouseDashboardQrCodeListStageWise;
